import $ from 'jquery';
import './utils/home-filter';
import './utils/apartments-filter';
import './utils/checkerboard';
import './utils/fasad-plan-zoom';
import { productApp } from '../../../../../../plugins/infocity/shop/assets/app';

// jquery — external (window.jQuery из core.js), fancybox должен вешаться на тот же инстанс
require('@fancyapps/fancybox');

$(function () {
    if (typeof $.fn.fancybox === 'function') {
        $('[data-fancybox="gallery"]').fancybox();
        $('[data-fancybox="news"]').fancybox();
        $('[data-fancybox="stories"]').fancybox({
            type: 'inline',
            toolbar: false,
            smallBtn: true,
        });
        $('[data-fancybox="comfort"]').fancybox();
    }

    productApp();
});

$('.app-product-wrapper .app-product-modal').click(function () {
    const productCard = $('#product' + $(this).data('product-id'));
    const productName = productCard.find('.app-product-name').text();
    const productArticle = productCard.find('.app-article-text').text();
    const input = $('<input>').attr({ type: 'hidden', name: 'Товар', value: productName });
    const input2 = $('<input>').attr({ type: 'hidden', name: 'Артикул', value: productArticle });
    const form = $('.app-product-form');
    const firstChild = form.children().first();
    if (firstChild.length) {
        form.prepend(input, input2);
    } else {
        form.append(input, input2);
    }
    $('.app-button-close').click(function () {
        input.remove();
        input2.remove();
    });
});

$('.app-product-item .app-product-modal').click(function () {
    const productCard = $('#productItem' + $(this).data('product-id'));
    const productName = productCard.find('.app-product-name').text();
    const productArticle = productCard.find('.app-article-text').text();
    const input = $('<input>').attr({ type: 'hidden', name: 'Товар', value: productName });
    const input2 = $('<input>').attr({ type: 'hidden', name: 'Артикул', value: productArticle });
    const form = $('.app-product-form');
    const firstChild = form.children().first();
    if (firstChild.length) {
        form.prepend(input, input2);
    } else {
        form.append(input, input2);
    }
    $('.app-button-close').click(function () {
        input.remove();
        input2.remove();
    });
});

$(document).ready(function () {
    const container = $('.license-container');
    const loadMoreButton = $('.load-more');
    if (!container.length) {
        return;
    }
    const itemsPerPage = 10;
    let currentPage = 1;
    const products = container.find('.license-wrapper');
    products.slice(itemsPerPage).hide();
    if (products.length <= itemsPerPage) {
        loadMoreButton.hide();
    }
    loadMoreButton.on('click', function () {
        const startIndex = currentPage * itemsPerPage;
        const endIndex = (currentPage + 1) * itemsPerPage;
        products.slice(startIndex, endIndex).show();
        currentPage++;
        if (endIndex >= products.length) {
            loadMoreButton.hide();
        }
    });
});

const slider = (element) => {
    const sliderEl = Boolean(element.classList) ? element : document.querySelector(element);
    if (!sliderEl) {
        return;
    }
    const rangeInput = sliderEl.querySelectorAll('.range-input input');
    const priceInput = sliderEl.querySelectorAll('.price-input input');
    const range = sliderEl.querySelector('.slider .progress');
    if (!range || rangeInput.length < 2 || priceInput.length < 2) {
        return;
    }

    const priceGap = 0.1;

    priceInput.forEach((input) => {
        input.addEventListener('input', () => {
            const minPrice = parseFloat(priceInput[0].value);
            const maxPrice = parseFloat(priceInput[1].value);
            if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                if (input.classList.contains('input-min')) {
                    rangeInput[0].value = minPrice;
                    range.style.left = ((minPrice / rangeInput[0].max) * 100) + '%';
                } else {
                    rangeInput[1].value = maxPrice;
                    range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + '%';
                }
            } else {
                rangeInput[0].value = minPrice;
                rangeInput[1].value = maxPrice;
            }
        });
    });

    rangeInput.forEach((input) => {
        input.addEventListener('input', () => {
            let minVal = parseFloat(rangeInput[0].value);
            let maxVal = parseFloat(rangeInput[1].value);
            if ((maxVal - minVal) < priceGap) {
                if (input.classList.contains('range-min')) {
                    rangeInput[0].value = (maxVal % 1 === 0 ? parseInt(maxVal, 10) : (maxVal - priceGap).toFixed(2));
                } else {
                    rangeInput[1].value = (minVal % 1 === 0 ? parseInt(minVal, 10) : (minVal + priceGap).toFixed(2));
                }
            } else {
                priceInput[0].value = (minVal % 1 === 0 ? parseInt(minVal, 10) : minVal.toFixed(2));
                priceInput[1].value = (maxVal % 1 === 0 ? parseInt(maxVal, 10) : maxVal.toFixed(2));
                range.style.left = ((minVal / rangeInput[0].max) * 100) + '%';
                range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
            }
        });
    });
};

document.querySelectorAll('.element').forEach((n) => slider(n));

$('.fasad-btn-link, .fasad-zone-link').on('mouseover', function () {
    const productId = $(this).data('product-id');
    $('.fasad-hover-block').each(function () {
        $(this).toggleClass('active', $(this).data('product-id') === productId);
    });
});

$('.fasad-btn-link, .fasad-zone-link').on('mouseout', function () {
    $('.fasad-hover-block').removeClass('active');
});

const $sunWrapper = $('.product-sun-wrapper');
const $utroButton = $('.product-sun-btn-morning');
const $denButton = $('.product-sun-btn-day');
const $vecherButton = $('.product-sun-btn-evening');
const $markerSunset = $sunWrapper.find('.product-sun-marker--sunset');
const $markerSunrise = $sunWrapper.find('.product-sun-marker--sunrise');

const SUN_MORNING = 180;
const SUN_DAY = 270;
const SUN_EVENING = 360;
const windRose = parseInt($sunWrapper.attr('data-wind-rose'), 10) || 0;

function setSun(base) {
    $sunWrapper.css('--sun-angle', base + 'deg');
}

function setSunActive($active) {
    $utroButton.add($denButton).add($vecherButton).removeClass('active');
    $active.addClass('active');
}

/**
 * Точки дуги в % сцены (0° = верх, по часовой).
 * Подпись только над или под точкой — у более высокой точки сверху, у нижней снизу.
 */
function placeSunLabels() {
    if (!$markerSunset.length || !$markerSunrise.length) {
        return;
    }
    const toPos = function (angleDeg) {
        const rad = (angleDeg * Math.PI) / 180;
        return {
            x: 50 + 50 * Math.sin(rad),
            y: 50 - 50 * Math.cos(rad)
        };
    };
    const sunset = toPos(windRose);
    const sunrise = toPos(windRose + 180);

    $markerSunset.css({ left: sunset.x + '%', top: sunset.y + '%' });
    $markerSunrise.css({ left: sunrise.x + '%', top: sunrise.y + '%' });

    if (sunset.y <= sunrise.y) {
        $markerSunset.addClass('is-above').removeClass('is-below');
        $markerSunrise.addClass('is-below').removeClass('is-above');
    } else {
        $markerSunset.addClass('is-below').removeClass('is-above');
        $markerSunrise.addClass('is-above').removeClass('is-below');
    }
}

placeSunLabels();

$utroButton.on('click', function (event) {
    event.preventDefault();
    setSun(SUN_MORNING);
    setSunActive($utroButton);
});

$denButton.on('click', function (event) {
    event.preventDefault();
    setSun(SUN_DAY);
    setSunActive($denButton);
});

$vecherButton.on('click', function (event) {
    event.preventDefault();
    setSun(SUN_EVENING);
    setSunActive($vecherButton);
});

$(document).ready(function () {
    $('.tab-pane').each(function () {
        const $tab = $(this);
        const $items = $tab.find('.app-built-image');
        const totalItems = $items.length;
        const shownItems = 9;
        $items.hide().slice(0, shownItems).show();

        if (totalItems > shownItems) {
            $tab.find('.app-built-btn').show();
        }

        $tab.find('.app-built-btn').click(function (e) {
            e.preventDefault();
            $items.filter(':hidden').slice(0, shownItems).fadeIn();
            if ($items.filter(':hidden').length === 0) {
                $(this).hide();
            }
        });
    });
});
